import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/simp_in/step1';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Initial } from '../../models/Initial';

@Component({
	selector: 'app-step1',
	templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {
	@Input() fnSimpleInitial: Initial;
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;
	public step1 = new Step1();

	constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
